
export class Facility {
    public name: string = '';
    public address: string = '';
    public address2: string = '';
    public city: string = '';
    public state: string = '';
    public zip: string = '';
    public latitude: number = 0.0;
    public longitude: number = 0.0;
    public timeZone: string = '';
}